/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { fetchTimeout } from "../components/Common";
import { API_BASE, Palette } from "../AppConfig";
import * as BSL_Common from "../components/BSL_CommonControls";
import { IconButton, LinearProgress, CircularProgress } from "@material-ui/core";
import SegmentedButtonGroup from "../components/SegmentedButtonGroup";
import Message from "../components/Message";
import BSL_TextInput from "../components/BSL_TextInput";
import BSL_Select from "../components/BSL_Select";
import BSL_DatePicker from "../components/BSL_DatePicker";
import BSL_UploadDocument from "../components/BSL_Upload/BSL_UploadDocument";
import BSL_Button from "../components/BSL_Button";
import Announcements from "../components_main/Announcements";
import { exp } from "mathjs";

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flex: "0 0 45%",
        flexDirection: "column",
        height: "90%",
        overflow: "auto",
    },
    iconButton: {
        fontSize: theme.brand.FIELDERS ? "16px" : "16px",
        fontFamily: theme.typography.fontFamilySecondary,
        fontWeight: "400",
        color: theme.palette.primary.main,
        marginTop: "-4px",
        borderRadius: "0%",
        textTransform: theme.brand.FIELDERS ? "uppercase" : "capitalize",
    },
    previewWrapper: {
        transform: "scale(0.5)",
        transformOrigin: "top left",
        width: "1750px",
        overflow: "hidden",
    },
}));

export default function SystemTools(props) {
    const classes = useStyles();
    const user = useSelector((state) => state.app.user);
    const [intialise, setIntialise] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    const [announcementList, setAnnouncementList] = React.useState([]);
    const [currentAnnouncement, setCurrentAnnouncement] = React.useState({});
    const [showMessage, setShowMessage] = React.useState(false);
    const [savingAnnouncement, setSavingAnnouncement] = React.useState(false);
    const [showPreview, setShowPreview] = React.useState(false);

    const today = new Date().setHours(0, 0, 0, 0);
    const isExpired = today > currentAnnouncement.valid_to_ts;

    const updateAnnouncement = (param) => (e, value) => {
        let val = value ?? e;
        if (val?.target?.value !== undefined) val = e?.target?.value;

        setCurrentAnnouncement((prev) => ({
            ...prev,
            [param]: val,
        }));
    };

    const handleSaveAnnouncement = async () => {
        setSavingAnnouncement(true);
        await saveAnnouncement();
        setSavingAnnouncement(false);
    };

    const isActive = currentAnnouncement?.status === "active" ?? false;

    React.useEffect(() => {
        if (!intialise) {
            let api_url = API_BASE() + "admin/getannouncementsall";
            if (window.LYSAGHT) api_url = API_BASE() + "admin/getannouncementsall/?b=L";
            fetchTimeout(api_url, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((json) => {
                    if (json.Message) throw json.Message;
                    setAnnouncementList(json);
                    setLoading(false);
                    setIntialise(true);
                })
                .catch((e) => {
                    setAnnouncementList([]);
                });
        }
    }, [intialise]);

    const saveAnnouncement = async () => {
        let api_url = API_BASE() + "admin/putannouncement";

        if (window.LYSAGHT) {
            api_url = API_BASE() + "admin/putannouncement/?b=L";
        }

        await fetchTimeout(api_url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(currentAnnouncement),
        })
            .then(async (response) => {
                if (response.status >= 200 && response.status <= 300) {
                    setLoading(true);
                    setIntialise(false);
                } else {
                    throw await response.text();
                }
            })
            .catch((e) => {
                setShowMessage({
                    type: "error",
                    message: "Announcement failed to save" + e,
                });
            });
    };

    const handleNewAnnouncement = () => {
        setShowPreview(true);
        setCurrentAnnouncement({
            id: Math.floor(Math.random() * 9999999999999).toString(),
            DocumentType: window.LYSAGHT ? "LLD_ANNOUNCEMENT" : "ANNOUNCEMENT",
            type: "general",
            status: "active",
            name: "",
            auto_display_trigger: "None",
            regions: "",
            header: "",
            content: "",
            valid_from_ts: today,
            valid_to_ts: today,
            image: "",
            creator: user?.Email,
            action_text: "",
            action_content: "",
            action_link: "",
        });
    };

    let announcementsSorted = [];
    for (var item of announcementList) {
        const expired = today > item.valid_to_ts ? " expired" : "";
        const autoDisplay = item.auto_display_trigger && item.auto_display_trigger !== "None" ? " auto" : "";
        const display = `${item.name} (${item.status}${expired}${autoDisplay})`;
        announcementsSorted.push({ Key: item.id, Display: display});
    }

    return (
        <div style={{ display: "flex", flexDirection: "row", height: "100%" }}>
            <div className={classes.root}>
                <BSL_Common.SectionContainer>
                    <BSL_Common.SectionRow style={{ borderBottom: "1px solid grey", alignItems: "flex-end" }}>
                        <BSL_Select
                            label={"Select Announcement"}
                            style={{ flex: 1, maxWidth: "400px" }}
                            value={currentAnnouncement?.id}
                            tight={true}
                            items={announcementsSorted}
                            onChange={(e) => {
                                for (var item of announcementList) {
                                    if (item?.id === e.target.value) {
                                        setCurrentAnnouncement(item);
                                        setShowPreview(true);
                                        break;
                                    }
                                }
                            }}
                        />
                        <BSL_Button onClick={handleNewAnnouncement} style={{ marginLeft: "30px" }}>
                            NEW ANNOUNCEMENT
                        </BSL_Button>
                    </BSL_Common.SectionRow>
                    {loading && <LinearProgress />}

                    {currentAnnouncement?.id && (
                        <div
                            style={{
                                display: "flex",
                                overflow: "auto",
                                textAlign: "left",
                                paddingRight: "10px",
                                flexDirection: "column",
                                width: "90%",
                            }}
                        >
                            <BSL_Common.SectionRow>
                                <SegmentedButtonGroup
                                    label="Status"
                                    style={{ flex: "none" }}
                                    value={currentAnnouncement.status}
                                    items={["active", "disable"]}
                                    onChange={updateAnnouncement("status")}
                                />
                                <SegmentedButtonGroup
                                    label="Type"
                                    style={{ flex: "none" }}
                                    value={currentAnnouncement.type}
                                    items={["general", "warning"]}
                                    onChange={updateAnnouncement("type")}
                                    disabled={!isActive}
                                />
                            </BSL_Common.SectionRow>
                            <BSL_Common.SectionRow style={{ alignItems: "anchor-center" }}>
                                <BSL_DatePicker
                                    label="Valid From"
                                    minDate={""}
                                    enableWeekends={true}
                                    value={currentAnnouncement.valid_from_ts}
                                    onChange={(date) =>
                                        updateAnnouncement("valid_from_ts")(new Date(date.setHours(0, 0, 1)).getTime())
                                    }
                                    style={{ width: "240px", flex: "none" }}
                                    disabled={!isActive}
                                />
                                <BSL_DatePicker
                                    label="Valid Until"
                                    minDate={currentAnnouncement.valid_from_ts}
                                    enableWeekends={true}
                                    value={currentAnnouncement.valid_to_ts}
                                    onChange={(date) => {
                                        let new_date_at_end_of_day = date.setHours(23, 59, 59);

                                        updateAnnouncement("valid_to_ts")(new Date(new_date_at_end_of_day).getTime());
                                    }}
                                    style={{ width: "240px", flex: "none" }}
                                    disabled={!isActive}
                                />
                                {isExpired && (
                                    <div
                                        style={{
                                            fontSize: "12pt",
                                            color: "red",
                                            marginLeft: "30px",
                                            paddingTop: "20px",
                                        }}
                                    >
                                        Expired
                                    </div>
                                )}
                            </BSL_Common.SectionRow>
                            <BSL_Common.SectionRow style={{ width: "80%" }}>
                                <BSL_TextInput
                                    label="Name"
                                    preValidate="name"
                                    value={currentAnnouncement.name}
                                    onBlur={updateAnnouncement("name")}
                                    disabled={!isActive}
                                />
                            </BSL_Common.SectionRow>
                            <BSL_Common.SectionRow style={{ width: "40%" }}>
                                <BSL_Select
                                    label={"Auto-Display Trigger"}
                                    value={currentAnnouncement.auto_display_trigger ?? "None"}
                                    items={["None", "System Outage"]}
                                    onChange={(e) => {
                                        updateAnnouncement("auto_display_trigger")(null, e.target.value);
                                    }}
                                    disabled={!isActive}
                                ></BSL_Select>
                            </BSL_Common.SectionRow>
                            <BSL_Common.SectionRow style={{ width: "80%" }}>
                                <BSL_TextInput
                                    label="Header"
                                    value={currentAnnouncement.header}
                                    onBlur={updateAnnouncement("header")}
                                    disabled={!isActive}
                                />
                            </BSL_Common.SectionRow>
                            <BSL_Common.SectionRow>
                                <BSL_UploadDocument
                                    buttonText="IMPORT THUMBNAIL..."
                                    backgroundText="UPLOAD"
                                    onSuccess={(message) => {
                                        updateAnnouncement("image")(null, message.filename);
                                        setShowMessage(message);
                                    }}
                                    onError={setShowMessage}
                                    onClear={() => {
                                        updateAnnouncement("image")(null, "");
                                    }}
                                    documentFolder="APP_announcements"
                                    documentFilename={currentAnnouncement.image}
                                    documentSaveFilename={currentAnnouncement.image}
                                    documentType="logo"
                                    sizeLimitMB={2}
                                    recompressImage={true}
                                    resizeImageByMaxWidth={300}
                                    disabled={!isActive}
                                />
                            </BSL_Common.SectionRow>
                            <BSL_Common.SectionRow>
                                <BSL_UploadDocument
                                    buttonText="IMPORT DOCUMENT..."
                                    backgroundText="UPLOAD"
                                    onSuccess={(message) => {
                                        updateAnnouncement("action_link")(
                                            API_BASE() + "Document/APP_announcements/" + message.filename
                                        );
                                        setShowMessage(message);
                                    }}
                                    onError={setShowMessage}
                                    onClear={() => {
                                        updateAnnouncement("action_link")(null, "");
                                    }}
                                    documentFolder="APP_announcements"
                                    documentFilename={currentAnnouncement.action_link.split("APP_announcements/")[1]}
                                    documentSaveFilename={currentAnnouncement.id + "_document"}
                                    documentType="logo"
                                    sizeLimitMB={2}
                                    recompressImage={true}
                                    resizeImageByMaxWidth={300}
                                    disabled={!isActive}
                                />
                            </BSL_Common.SectionRow>
                            <BSL_Common.SectionRow>
                                <BSL_TextInput
                                    label="Content"
                                    multiline
                                    rows={3}
                                    style={{
                                        flex: 1,
                                    }}
                                    value={currentAnnouncement.content}
                                    onBlur={updateAnnouncement("content")}
                                    disabled={!isActive}
                                />
                            </BSL_Common.SectionRow>
                            <BSL_Common.SectionRow>
                                <BSL_TextInput
                                    label="Action Extra Content/Details"
                                    multiline
                                    rows={2}
                                    style={{
                                        flex: 1,
                                    }}
                                    value={currentAnnouncement.action_content}
                                    onBlur={updateAnnouncement("action_content")}
                                    helperText={"Text in this box creates a dialog box from all of the ACTION inputs."}
                                    disabled={!isActive}
                                />
                            </BSL_Common.SectionRow>
                            <BSL_Common.SectionRow>
                                <BSL_TextInput
                                    label="Action Link Text"
                                    value={currentAnnouncement.action_text}
                                    onBlur={updateAnnouncement("action_text")}
                                    disabled={!isActive}
                                />
                            </BSL_Common.SectionRow>
                            <BSL_Common.SectionRow>
                                <BSL_TextInput
                                    label="Action Link URL"
                                    value={currentAnnouncement.action_link}
                                    onBlur={updateAnnouncement("action_link")}
                                    disabled={!isActive}
                                />
                            </BSL_Common.SectionRow>
                            <IconButton
                                className={classes.iconButton}
                                classes={{ root: classes.iconButtonRoot }}
                                disabled={savingAnnouncement}
                                onClick={handleSaveAnnouncement}
                                style={{
                                    width: "150px",
                                    height: "40px",
                                }}
                            >
                                SAVE
                                <span style={{ width: "20px", marginLeft: "20px" }}>
                                    {savingAnnouncement && <CircularProgress size={15} />}
                                </span>
                            </IconButton>
                        </div>
                    )}
                </BSL_Common.SectionContainer>
                <Message
                    open={showMessage}
                    message={showMessage?.message}
                    type={showMessage?.type}
                    onClose={() => setShowMessage(null)}
                />
            </div>
            {showPreview && (
                <div className={classes.root} style={{ justifyContent: "center", paddingLeft: "20px" }}>
                    <BSL_Common.SectionSubHeader>Announcement Preview</BSL_Common.SectionSubHeader>
                    <div className={classes.previewWrapper}>
                        <Announcements previewAnnouncement={currentAnnouncement} />
                    </div>
                    {window.debug && <pre>{JSON.stringify(currentAnnouncement, null, 2)}</pre>}
                </div>
            )}
        </div>
    );
}
